import React from 'react';
import SignIn from '../components/SignIn';


const Login = () => {
	return <SignIn/>
}

export default Login
